import React, {useEffect, useRef, useState} from 'react';

import styles from './styles/upload-list.module.css';

import FileBox from './FileBox';

export default function UploadList({ uploadFileList = [], removeFile }) {
    const containerRef = useRef(null);

    const [isAtBottom, setIsAtBottom] = useState(false);

    const checkScrollPosition = () => {
        if (containerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
            setIsAtBottom(scrollHeight - scrollTop - clientHeight < 5); // 스크롤이 바닥에 도달했는지 확인 (5px 오차 허용)
        }
    };

    const handleScroll = () => { // 스크롤 이벤트 발생 시 호출
        checkScrollPosition();
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            checkScrollPosition();
        }
        
        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    useEffect(() => {
        checkScrollPosition();
    }, [uploadFileList]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container} ref={containerRef}> {/* 페이드 효과를 위한 div */}
                {uploadFileList.map((file, index) => (
                    <FileBox index={index} file={file} removeFile={removeFile} />
                ))}
            </div>
            {uploadFileList.length > 5 && !isAtBottom && <div className={styles.fadeEffect}></div>}
        </div>
    );
}
